import * as React from 'react'
import { useState } from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import PlusIcon from '../icons/plus'
import MinusIcon from '../icons/minus'

const SimpleAccordion = ({ items }) => {
    const [expanded, setExpanded] = useState(false);
    const titleColor = '#DB684D'; // Definime värvi muutujana, et seda korduvkasutada

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
      <div className="accordion">
          {items.map((item, index) => {
              const panelName = `panel${index}`;
              const isCurrentExpanded = expanded === panelName;

              return (
                <Accordion
                  key={index}
                  disableGutters
                  elevation={0}
                  expanded={expanded === panelName}
                  onChange={handleChange(panelName)}
                  sx={{
                      backgroundColor: 'transparent',
                      color: '#fff',
                      borderRadius: 0, // Võtab ümaruse ära
                      borderBottom: `1px solid ${titleColor}`, // Sama värv mis title
                      '&:last-of-type': {
                          borderBottom: 'none', // Viimasel elemendil pole joont all
                      },
                      '&:before': { display: 'none' }, // MUI vaikimisi joon peidus
                  }}
                >
                    <AccordionSummary
                      expandIcon={isCurrentExpanded ? <MinusIcon /> : <PlusIcon />}
                      sx={{
                          padding: '24px 0',
                          '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
                              transform: 'none', // Peatab ikooni keerlemise
                          },
                          '& .MuiAccordionSummary-content': {
                              margin: 0,
                          },
                      }}
                    >
                        <div style={{
                            fontSize: '18px',
                            fontWeight: 500,
                            color: titleColor,
                            textTransform: 'uppercase' // Teeb teksti suurteks tähtedeks
                        }}>
                            {item.title}
                        </div>
                    </AccordionSummary>

                    <AccordionDetails sx={{ padding: '0 0 24px 0', color: '#fff' }} className={'recipe-content'}>
                        <div dangerouslySetInnerHTML={{ __html: item.content }}></div>
                    </AccordionDetails>
                </Accordion>
              );
          })}
      </div>
    );
};

export default SimpleAccordion;